var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{attrs:{"label":_vm.item.title,"description":_vm.item.helpText}},[_c('ChooseFiles',{model:{value:(_vm.item.value),callback:function ($$v) {_vm.$set(_vm.item, "value", $$v)},expression:"item.value"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }